import ForgotPassword from '@/components/Auth/ForgotPassword'

const ForgotPasswordScreen = () => {
  return <ForgotPassword />
}

export default ForgotPasswordScreen
